import { Box, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import { setBranchByBusinress } from "../../../lib/slices/branch";
import { setUserPro } from "../../../lib/slices/businessPro";
import { setUserRoutes } from "../../../lib/slices/path";
import { setSelectedBranch } from "../../../lib/slices/selectedBranch";
import { setUser } from "../../../lib/slices/userSlice";
import { handleLogin, handleLoginAsBusiness } from "../../../services/Auth";
import { loginValidation } from "../../../utils/Validation";

const LoginForm = () => {
  const { search } = useLocation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [inputValues, setInputValues] = useState({
    email: "",
    password: "",
  });
  const [inputError, setInputError] = useState({
    email: false,
    isEmailValid: false,
    password: false,
  });

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (search) {
      localStorage.removeItem("user-data");
      localStorage.removeItem("token");
      localStorage.removeItem("business-subscription");
      dispatch(setUser(null));
      handleLoginAdminAsBusiness();
    }
  }, [search]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleLoginAdminAsBusiness = async () => {
    try {
      setIsLoading(true);
      const responce = await handleLoginAsBusiness({
        email: search?.slice(7),
      });
      setIsLoading(false);
      const data = responce?.data?.data;
      if (responce?.status == 200 || responce?.status == 201) {
        if (data?.profileData == null) {
          localStorage.setItem("user-data", JSON.stringify(data?.userDetails));
          localStorage.setItem("token", JSON.stringify(data?.token));
          dispatch(setUser(data?.userDetails));
          setTimeout(() => {
            navigate("/sign-up/verify", { replace: true });
          }, 500);
        } else {
          navigate("/dashboard", { replace: true });
          localStorage.setItem("user-routes", JSON.stringify(data?.pages));
          dispatch(setUserRoutes(data?.pages));
          localStorage.setItem("user-data", JSON.stringify(data?.userDetails));
          dispatch(setUser(data?.userDetails));
          localStorage.setItem("token", JSON.stringify(data?.token));
          localStorage.setItem("user-Pro", JSON.stringify(data?.profileData));
          dispatch(setUserPro(data?.profileData));
          dispatch(setBranchByBusinress(data?.branches));
          localStorage.setItem("branchIds", JSON.stringify(data?.branches));
          let branchesIds = data?.branches.map((item) => item._id);
          dispatch(setSelectedBranch(branchesIds));
        }
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log(error, "errorerrorerrorerrorerror");
    }
  };

  const handleUserLogin = async () => {
    try {
      const validate = loginValidation(inputValues, setInputError);
      if (validate) {
        return;
      }
      let payload = {
        email: inputValues.email,
        password: inputValues.password,
      };
      setIsLoading(true);
      const responce = await handleLogin(payload);
      setIsLoading(false);
      const data = responce?.data?.data;

      if (responce?.status == 200 || responce?.status == 201) {
        if (data?.profileData == null) {
          localStorage.setItem("user-data", JSON.stringify(data?.userDetails));
          localStorage.setItem("token", JSON.stringify(data?.token));
          dispatch(setUser(data?.userDetails));
          setTimeout(() => {
            navigate("/sign-up/verify", { replace: true });
          }, 500);
        } else {
          navigate("/dashboard", { replace: true });
          localStorage.setItem("user-routes", JSON.stringify(data?.pages));
          dispatch(setUserRoutes(data?.pages));
          localStorage.setItem("user-data", JSON.stringify(data?.userDetails));
          dispatch(setUser(data?.userDetails));
          localStorage.setItem("token", JSON.stringify(data?.token));
          localStorage.setItem("user-Pro", JSON.stringify(data?.profileData));
          dispatch(setUserPro(data?.profileData));
          dispatch(setBranchByBusinress(data?.branches));
          localStorage.setItem("branchIds", JSON.stringify(data?.branches));
          let branchesIds = data?.branches.map((item) => item._id);
          dispatch(setSelectedBranch(branchesIds));
        }
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log(error, "errorerrorerrorerrorerror");
    }
  };

  const handleChangeValues = (event) => {
    const { name, value } = event.target;
    setInputError((prevError) => ({
      ...prevError,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
    }));
    setInputValues((pre) => ({ ...pre, [name]: value }));
  };

  return (
    <Box component={"form"} sx={{ mt: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Label labelText="User Id" htmlFor={"user-id"} required />
          <TextInput
            inputError={inputError.email || inputError.isEmailValid}
            helperText={
              inputError.email
                ? "Email is required"
                : inputError.isEmailValid
                ? "Invalid email format"
                : null
            }
            id={"user-id"}
            required={true}
            placeholder={"Enter Email Address"}
            type={"email"}
            name="email"
            value={inputValues.email}
            onChange={handleChangeValues}
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText="Password" htmlFor={"password"} required />
          <TextInput
            inputError={inputError.password}
            helperText={inputError.password ? "Password is required" : null}
            id={"password"}
            required
            placeholder={"Enter Password"}
            type={showPass ? "text" : "password"}
            name="password"
            value={inputValues.password}
            onChange={handleChangeValues}
            InputEndIcon={
              showPass ? (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowPass(false)}
                >
                  Hide
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowPass(true)}
                >
                  Show
                </Typography>
              )
            }
          />
        </Grid>
      </Grid>
      <Stack alignItems={"flex-end"} mt={0.5}>
        <Link
          to={"/forgot-password"}
          className="react-router-link"
          style={{
            color: appcolors.lightGrey,
          }}
        >
          Forgot Password
        </Link>
      </Stack>
      <Box mt={3}>
        <GlobalButton
          variant={"contained"}
          btnText={"Login"}
          handleClickBtn={handleUserLogin}
        />
      </Box>
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
    </Box>
  );
};

export default LoginForm;
